import {flatten1} from "@Common/utils/collections";

export const remapPricingData = (data) => {
    if (Array.isArray(data)) {
        return data;
    }
    return flatten1(Object.keys(data).map((paperType) => {
        const paperData = data[paperType];
        return Object.keys(paperData)
            .filter((deliveryType) => deliveryType === "DOWNLOAD" || paperData[deliveryType].length > 0)
            .map((deliveryType) => ({
                paperType,
                deliveryType,
                prices: paperData[deliveryType],
            }))
            ;
    }));
};